// For now, this is a simple check for the encoded version of liquid brackets with anything
// in between (e.g. "%7B%7Bsome%20stuff%7D%7D", which decoded would be "{{some stuff}}")
export const hasEncodedLiquidSyntax = (text: string) => {
  return /(%7B%7B*(.+)%7D%7D)|(%7B%25*(.+)%25%7D)/.test(text);
};
